import { render, staticRenderFns } from "./Ubicacion.vue?vue&type=template&id=6702fb96&"
import script from "./Ubicacion.vue?vue&type=script&lang=js&"
export * from "./Ubicacion.vue?vue&type=script&lang=js&"
import style0 from "./Ubicacion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports